// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchHeader":"WT","sortWrapper":"XT","shortCount":"YT","fullCount":"ZT","countWrapper":"_T"};